export const insuranceCompanies = '/insurance-companies';
export const insuranceCompany = (id: number) => `/insurance-companies/${id}`;
